import { Link } from 'react-router-dom'
import { EtiquetaDeStatus } from '../../components/Etiqueta'
import { TEXTOS } from '../../lib/glossario'
import type { StatusGmud } from '../../types/gmud'
import type { CommitNaTela } from '../../types/repositorios'

/** A moldura de um chip: preenchimento claro, texto escuro, como as etiquetas de estado. */
export const CHIP = 'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset'

/**
 * A célula da solicitação de um commit, com os três estados que a tela distingue com todas as
 * letras: a solicitação existe (link e estado dela); a mensagem cita um código que não existe (o
 * erro de digitação que interessa a quem escreveu); e nada foi citado — que só é destacado em
 * commit de trabalho, porque integração não cita mesmo.
 *
 * @param props o commit
 * @returns o conteúdo da célula
 */
export function CelulaDaSolicitacao({ commit }: { commit: CommitNaTela }) {
  const t = TEXTOS.repositorios.commits
  if (commit.solicitacao) {
    return (
      <span className="flex flex-wrap items-center gap-1.5">
        <Link
          to={`/gmuds/${commit.solicitacao.id}`}
          className="font-medium text-niteroi-700 underline underline-offset-2 hover:text-niteroi-900"
        >
          {commit.solicitacao.codigo}
        </Link>
        <EtiquetaDeStatus status={commit.solicitacao.status as StatusGmud} />
      </span>
    )
  }
  if (commit.gmudCodigoCitado) {
    return <span className={`${CHIP} bg-red-50 text-red-900 ring-red-200`}>{t.codigoNaoEncontrado(commit.gmudCodigoCitado)}</span>
  }
  if (commit.integracao) {
    return <span className="text-slate-400">—</span>
  }
  return <span className={`${CHIP} bg-amber-50 text-amber-900 ring-amber-200`}>{t.semSolicitacao}</span>
}
